module.exports = __webpack_public_path__ + "static/img/banner_04.f7d93f34.png";